@use '@/styles/tokens' as *;

.cell {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  max-width: 100%;
}

.name {
  min-width: 0;
  flex: 1 1 auto;
}

.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 var(--space-1);
  border: 0;
  border-radius: 50%;
  background: $color-neutral-900; // #1A1A1A
  color: $color-neutral-0; // #FFFFFF — palette is SCSS-var only, not a CSS custom prop
  font-size: 11px;
  cursor: pointer;

  &:focus-visible {
    outline: none;
    box-shadow: var(--focus-ring);
  }
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  max-height: 240px;
  overflow-y: auto;
}
